import { WprBaseScopeInfo } from '../wpr-framework/scope/WprBaseScopeInfo';
import { PlanInfo } from '../models/PlanInfo';
import { ContractorInfo } from '../models/ContractorInfo';
import { TravelerInfo } from '../models/TravelerInfo';
import { LoginInfo } from '../models/LoginInfo';
import { BasicInfo } from '../models/BasicInfo';
import { OthersInfo } from '../models/OthersInfo';
import { SpecialProvision } from '../models/SpecialProvision';
import { ScrollPositionInfo } from '../models/ScrollPositionInfo';
import { ContractNoticeInfo } from '../service/models/contract-notice/contract-notice-info';
import { CollateralDisplayInfo } from '../service/models/collateral-display/collateral-display-info';
import { Coverage } from '../service/models/coverage/coverage';
import { PaymentInfo } from '../service/models/payment/payment-info';
import { InsuredInfo } from '../service/models/insured/insured-info';
import { RiskFactorInfo } from '../service/models/risk-factor/risk-factor-info';
import { SelectPlanInfo } from '../service/models/select-plan/select-plan-info';
import { PolicyHolderInfo } from '../service/models/policy-holder/policy-holder-info';
import { AuthMailInfo } from '../service/models/auth-mail/auth-mail-info';

/**
 * 後半スコープ情報
 */
export class SecondScopeInfo extends WprBaseScopeInfo {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() { 
		super('後半スコープ情報'); 
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
     * 初期化通知
     */
	public onInitialize(): void {
		// 基本情報
		const basicInfo = new BasicInfo();
		this.setScopeModel('BasicInfo', basicInfo);
		// 保険プラン詳細情報
		const planInfo = new PlanInfo();
		this.setScopeModel('PlanInfo', planInfo);
		// 契約者（申込者）情報
		// const contractorInfo = new ContractorInfo();
		// let today = new Date();
		// contractorInfo.year = (today.getFullYear() - 30).toString();
		// contractorInfo.month = '1';
		// contractorInfo.date = '1';
		// this.setScopeModel('ContractorInfo', contractorInfo);
		// 旅行者（記名被保険者）情報
		// const travelerListInfo = [];
		// for (let i = 0; i < 2; i++)
		// 	travelerListInfo.push(new TravelerInfo());
		// this.setScopeModel('TravelerInfo', travelerListInfo);
		// ログイン情報	
		const loginInfo = new LoginInfo();
		this.setScopeModel('LoginInfo', loginInfo);
		// 特約・約款情報
		const specialProvision = new SpecialProvision();
		this.setScopeModel('SpecialProvision', specialProvision);
		// 告知事項
		const contractNoticeInfo = new ContractNoticeInfo();
		this.setScopeModel('ContractNoticeInfo', contractNoticeInfo);
		// その他情報
		const othersInfo = new OthersInfo();
		this.setScopeModel('OthersInfo', othersInfo);
		// 画面スクロール位置情報
		const scrollPositionInfo = new ScrollPositionInfo();
		this.setScopeModel('ScrollPositionInfo', scrollPositionInfo);
		// 
		const riskfactorInfo = new RiskFactorInfo();
		this.setScopeModel('RiskFactorInfo', riskfactorInfo);
		// 
		const selectPlanInfo = new SelectPlanInfo();
		this.setScopeModel('SelectPlanInfo', selectPlanInfo);
		//
		const insuredInfolist = [];
		this.setScopeModel('InsuredInfoList', insuredInfolist);
		// 
		const policyHolderInfo = new PolicyHolderInfo();
		this.setScopeModel('PolicyHolderInfo', policyHolderInfo);
		const authMailInfo = new AuthMailInfo();
		this.setScopeModel('AuthMailInfo', authMailInfo);
	}
	// --------------------------------------------------------------------------
}